import { Image, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'

import downloadIcon from '../../../../../../../../assets/download.svg'
import { userTimezone } from '../../../../../../../../App'

export default function Invoice({ invoice }) {
  const { t } = useTranslation()

  const inputDate = invoice?.date
    ? DateTime.fromMillis(invoice?.date, {
        zone: 'utc',
      })
        .setZone(userTimezone)
        .toFormat('dd/MM/yyyy HH:mm')
    : '-'

  return (
    <Flex flex='1' gap='8px'>
      <Flex flex='2' align='center'>
        <Text fontSize='13px' fontWeight='600'>
          {inputDate}
        </Text>
      </Flex>
      <Flex flex='3' align='center'>
        {invoice.invoiceURL ? (
          <Flex gap='8px' align='center'>
            <Text fontSize='13px' fontWeight='600'>
              {invoice.invoiceName}
            </Text>
            <a href={invoice.invoiceURL} target='_blank' rel='noreferrer'>
              <Image src={downloadIcon} />
            </a>
          </Flex>
        ) : (
          <Text fontSize='13px' fontWeight='600'>
            -
          </Text>
        )}
      </Flex>
      <Flex flex='2' align='center' justify={{ sm: 'flex-end', lg: 'flex-start' }}>
        {invoice.creditNoteURL || invoice.invoiceURL ? (
          <Text
            fontSize='13px'
            fontWeight='600'
            textTransform='uppercase'
            color={invoice.status === 1 ? '#6172F3' : '#98A2B3'}
          >
            {t(invoice?.status === 1 ? 'travel_history.issued' : 'travel_history.cancelled')}
          </Text>
        ) : (
          <Text fontSize='13px' fontWeight='600'>
            -
          </Text>
        )}
      </Flex>
      <Flex flex='2' align='center' display={{ sm: 'none', md: 'flex' }}>
        {invoice.creditNoteURL ? (
          <Flex gap='8px' align='center'>
            <Text fontSize='13px' fontWeight='600'>
              {invoice.creditNoteName}
            </Text>
            <a href={invoice.creditNoteURL} target='_blank' rel='noreferrer'>
              <Image src={downloadIcon} />
            </a>
          </Flex>
        ) : (
          <Text fontSize='13px' fontWeight='600'>
            -
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
